<template>
    <div class="popup" :class="{'popup--menu': menuMode}" :id="options.popupId">
        <slot></slot>
    </div>
</template>

<script>


import {localPackLogger} from "@/2_app-logic/utils/utils";

export default {
    name: 'zPopup',
    props: {
        customOptions: {
            type: Object,
            default: () => {},
        },
        multiTrigger: {
            type: Boolean,
            default: false,
        },
        menuMode: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        popup: null,
        currentTriggerElement: null,
        popupContainer: null,
        menuItems: null,
        offset: 0,
        
        triggerElOnPopupDefaultClass: 'popupTriggerBtn--onPopup', // Есть дефолтные классы, которые нельзя переназначить в отличие от опций
        defaultOptions: {
            // Внутренние стили, переназначать нежелательно
            menuClass: 'popup',
            menuShowClass: 'popup--show',
            menuItemClass: 'popup__item',
        
            // Клиентские уникальные стили
            popupId: 'popup',
            triggerElUniqSelector: '.',
            containerElUniqSelector: '.',
            
            // Необязательные
            popupContainerOnClass: 'popupContainer--on',
            triggerElOnPopupClass: 'default',
            heightCompensation: null,
            widthCompensation: null,
            
            onClose: function () {
                // do something custom after popup close
            },
            onChoice: function () {
                // do something custom after user choice
                // this.hidePopup() // TODO Обращение через this не работает
            },
        }
    }),
    computed: {
        options() {
            return {...this.defaultOptions, ...this.customOptions}
        }
    },
    methods: {
        //////////////////////
        // Базовые действия //
        initPopup() {
            try {
                document.body.addEventListener('click', this.pastClickHandler)
                this.popup.addEventListener('click', this.popupClickHandler)
            
                // return {
                //     triggerElementClickHandler: this.triggerElementClickHandler,
                //     hidePopup: this.hidePopup,
                // }
            } catch (error) {
                localPackLogger.warn(error)
            }
        },
        showPopup() {
            localPackLogger.log('showPopup', 0);
            if (this.popup && this.currentTriggerElement) {
                localPackLogger.log('showPopup', 1);
                const customContainer = document.querySelector(this.options.containerElUniqSelector)
                this.popupContainer = customContainer ? customContainer : this.currentTriggerElement.parentElement
                this.popupContainer.style.position = 'relative'
    
                this.popupContainer.appendChild(this.popup)
                this.popupContainer.classList.add(this.options.popupContainerOnClass)
                this.currentTriggerElement.classList.add(this.options.triggerElOnPopupClass, this.triggerElOnPopupDefaultClass)
    
                this.popup.classList.add(this.options.menuShowClass)
                setPopupPosition.call(this)
    
                setMenuItemLeftPadding.call(this)
            }
            
            function setPopupPosition() {
                if (this.menuMode) {
                    this.popup.style.top = this.currentTriggerElement.offsetTop - this.offset + 'px'
                    this.popup.style.left = this.currentTriggerElement.offsetLeft - this.offset + 'px'
                }
                else {
                    const rect = this.currentTriggerElement.getBoundingClientRect()
                    
                    this.popup.style.top = this.currentTriggerElement.offsetTop + heightCompensation(this.options, rect) + 'px'
                    this.popup.style.left = this.currentTriggerElement.offsetLeft + widthCompensation(this.options, rect) + 'px'
    
                    // localPackLogger.log(rect, this.currentTriggerElement.offsetTop, this.currentTriggerElement.offsetLeft);
                }
                
                function heightCompensation(options, rect) {
                    return options.heightCompensation ? options.heightCompensation : rect.height - 2
                }
                
                function widthCompensation(options, rect) {
                    return options.widthCompensation ? options.widthCompensation : (rect.width / 2)
                }
            }
            
            function setMenuItemLeftPadding() {
                if (this.menuMode) {
                    new Array().forEach.call(this.menuItems, (menuItem) => {
                        menuItem.style.paddingLeft = this.currentTriggerElement.offsetWidth + this.offset * 2 + 'px'
                    })
                }
            }
        },
        closePopup() {
            localPackLogger.log('closePopup');
            this.hidePopup()
            this.options.onClose && this.options.onClose()
        },
        hidePopup() {
            // localPackLogger.log('hidePopup', 0);
            if (this.isPopupOpen()) {
                // localPackLogger.log('hidePopup', 1);
                this.popup.classList.remove(this.options.menuShowClass)
                this.currentTriggerElement.classList.remove(this.options.triggerElOnPopupClass, this.triggerElOnPopupDefaultClass)
                this.popupContainer.classList.remove(this.options.popupContainerOnClass)
            }
        },
        // Базовые действия //
        //////////////////////
    
        /////////////////////////
        // Обработчики событий //
        /**
         * Обработчик клика мимо попапа
         * Поведение: закрываем попап.
         */
        pastClickHandler(event) {
            const element = event.target
            // localPackLogger.log('pastClickHandler', 0, element);
    
            if (this.currentTriggerElement && !this.isTriggerElement(element) && !this.isPopup(element)) {
                // localPackLogger.log('pastClickHandler', 1, element);
                this.closePopup()
            }
        },
        /**
         * Обработчик клика по тригерному элементу, открывшему попап
         * Поведение: открываем или закрываем попап.
         */
        triggerElementClickHandler(event) {
            const element = this.isTriggerElement(event.target)
            
            if (element) {
                console.log(!!this.currentTriggerElement, this.isTriggerElement__on(element))
                
                if (this.currentTriggerElement && this.isTriggerElement__on(element)) {
                    this.closePopup()
                } else {
                    if (this.multiTrigger) { // Если множество триггеров на один попап, тогда закрываем в предыдущем месте
                        this.currentTriggerElement && this.closePopup()
                    }
                    this.currentTriggerElement = element
                    this.showPopup()
                }
            }
        },
        /**
         * Обработчик кликов по попапу
         */
        popupClickHandler(event) {
            const element = event.target
            // localPackLogger.log('popupClickHandler', 0)
            if (this.isMenuItem(element)) {
                // localPackLogger.log('popupClickHandler', 1)
                this.options.onChoice && this.options.onChoice(element)
            }
        },
        // Обработчики событий //
        /////////////////////////
    
        ///////////////
        // Предикаты //
        isPopup(element) {
            return element.closest('#' + this.options.popupId)
        },
        
        isTriggerElement(element) {
            return element.closest(this.options.triggerElUniqSelector)
        },
    
        /**
         * Клик по тригеру, когда попап открыт
         */
        isTriggerElement__on(element) {
            const closestElement = element.closest(this.options.triggerElUniqSelector)
            return closestElement && closestElement.classList.contains(this.triggerElOnPopupDefaultClass)
        },
        
        isMenuItem(element) {
            return element.closest('.' + this.options.menuItemClass)
        },
        isPopupOpen() {
            return this.popupContainer &&
                this.popup &&
                this.currentTriggerElement &&
                this.popup.classList.contains(this.options.menuShowClass)
        },
        // Предикаты //
        ///////////////
    },
    mounted() {
        this.popup = document.getElementById(this.options.popupId),
        this.menuItems = this.popup.querySelectorAll('.' + this.options.menuItemClass),
        this.initPopup()
    },
    destroyed() {
        document.body.removeEventListener('click', this.pastClickHandler)
    }
    
}

</script>

<style lang="less">
@text-color: #333;
@text-color-mute: #777;

.popup {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 80;
    background-color: #fafafa;
    border-radius: 3px;
    box-shadow: 0 2px 14px rgba(0, 0, 0, .2);
    max-width: 800px;
    min-width: 180px;
    padding: 8px 0;
    max-height: 300px;
    overflow: auto;
    font-size: 14px;
    &.popup--menu {
        .popupTriggerBtn--onPopup {
            position: relative;
            z-index: 81;
        }
    }
}
.popup__item {
    display: block;
    padding: 6px 24px 4px 25px;
    font-size: 1em;
    font-weight: 400;
    color: @text-color;
    letter-spacing: inherit;
    line-height: 1.3em;
    outline: 0;
    white-space: nowrap;
    &:not(.popup__item--noHover):not(.popup__item--noPointer) {
        cursor: pointer;
    }
    &:hover:not(.popup__item--noHover) {
        background-color: #eee;
    }
}

.popup__header {
    padding: 6px 24px 4px;
    white-space: nowrap;
    font-size: 0.9em;
    font-weight: 700;
}

.popup__noData {
    padding: 10px 24px;
    white-space: nowrap;
    font-size: 0.9em;
}

.popup__itemIcon {
    width: 15px;
    color: @text-color-mute;
    font-size: 0.9em;
}
.popup--show {
    display: block;
}
.popup select [disabled] {
    appearance: none;
    color: @text-color;
    opacity: 0.5;
}


.popupContainer {
    position: relative;
}

</style>